export const getDecisionTreeList = () => ({apis}) => {
  let payload = apis.getDecisionTreeList().map((x) => x)
  return {
    type: 'GET_COMPANY_TREE_LIST',
    payload,
  }
}

export const getDecisionTreeDetails = (provinerId, companyId) => ({apis}) => {
  let payload = apis.getDecisionTreeData(provinerId, companyId).map((x) => x)
  return {
    type: 'GET_DECISION_TREE_DATA',
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/store/decision-tree/actions.js